import { motion } from "framer-motion";
import { Target, HeartHandshake, Leaf } from "lucide-react";

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
};

export const About = () => {
  return (
    <section id="about" data-testid="about-section" className="bg-[#F9FAF8] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-5 md:px-8 grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-80px" }}
        >
          <p className="font-display text-xs font-bold uppercase tracking-[0.25em] text-[#1B4332] mb-4">About Us</p>
          <h2 className="font-display text-3xl md:text-4xl font-bold tracking-tight text-[#081C15]" data-testid="about-heading">
            A Canadian partner to the poultry industry
          </h2>
          <p className="mt-6 text-base md:text-lg text-gray-700 leading-relaxed">
            IMR Poultry Solutions Inc. is a Canadian poultry barn cleaning and sanitation
            services company supporting poultry producers, farm operators, and agricultural
            businesses across Canada.
          </p>
          <p className="mt-4 text-base text-gray-700 leading-relaxed">
            We believe that maintaining clean and properly sanitized poultry facilities is an
            important part of responsible poultry production. Our goal is to help farmers
            protect their facilities, support biosecurity practices, and maintain professional
            agricultural environments.
          </p>

          <div className="mt-10 space-y-6">
            <div className="flex gap-4">
              <span className="shrink-0 w-11 h-11 rounded-lg bg-[#1B4332] flex items-center justify-center">
                <Target size={19} className="text-[#D4AF37]" />
              </span>
              <div>
                <h3 className="font-display font-semibold text-lg text-[#081C15]">Our Mission</h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  Cleaner barns. Stronger farms. Dependable service that keeps your operation ready for continued production.
                </p>
              </div>
            </div>
            <div className="flex gap-4">
              <span className="shrink-0 w-11 h-11 rounded-lg bg-[#1B4332] flex items-center justify-center">
                <HeartHandshake size={19} className="text-[#D4AF37]" />
              </span>
              <div>
                <h3 className="font-display font-semibold text-lg text-[#081C15]">Our Commitment</h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  Attention to detail and high standards of cleanliness and biosecurity on every barn we service.
                </p>
              </div>
            </div>
            <div className="flex gap-4">
              <span className="shrink-0 w-11 h-11 rounded-lg bg-[#1B4332] flex items-center justify-center">
                <Leaf size={19} className="text-[#D4AF37]" />
              </span>
              <div>
                <h3 className="font-display font-semibold text-lg text-[#081C15]">Our Vision</h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  A trusted service provider within Canada's poultry and agricultural industry.
                </p>
              </div>
            </div>
          </div>
        </motion.div>

        <motion.div
          className="relative"
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-80px" }}
        >
          <div className="absolute -top-6 -right-6 w-40 h-40 bg-[#1B4332] rounded-xl" aria-hidden="true" />
          <img
            src="https://images.unsplash.com/photo-1548550023-2bdb3c5beed7?auto=format&fit=crop&w=1200&q=80"
            alt="Healthy hen on a Canadian poultry farm"
            data-testid="about-image"
            className="relative rounded-xl w-full h-[380px] md:h-[520px] object-cover shadow-[0_16px_50px_rgba(27,67,50,0.18)]"
          />
          <div className="absolute -bottom-6 left-6 bg-[#D4AF37] text-[#081C15] rounded-lg px-6 py-4 shadow-lg" data-testid="about-mission-stamp">
            <p className="font-display font-black text-lg leading-tight">Cleaner Barns.</p>
            <p className="font-display font-black text-lg leading-tight">Stronger Farms.</p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
